import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {UICommand} from "shared/constants";
import { IUICommandAction, IUICommandState } from "dataModels/stateModels/uiCommand";


const uiCommandsInitialState:IUICommandState = {
    uiCommand:undefined
}
//Used to dispatch commands (as i.e. reload data)
export const UiCommandSlice = createSlice({
    name:"uiCommands",
    initialState:uiCommandsInitialState,
    reducers:{
        setCommand(state:IUICommandState, action:PayloadAction<IUICommandAction>){
            state.uiCommand =  action.payload.uiCommand;
        },
        setReloadCommand(state:IUICommandState){
            state.uiCommand = UICommand.RELOAD;
        },
        resetCommand(state:IUICommandState){
            state.uiCommand = undefined;
        }
    }
});
export const {setCommand, resetCommand, setReloadCommand} = UiCommandSlice.actions;
export default UiCommandSlice.reducer;